import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "bookcontentstatus"
    }}>{`BookContentStatus`}</h1>
    <p>{`Book content file status options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NORMAL`}</strong>{` = 1852797549`}</p>
      <p parentName="blockquote">{`The book content object is not open and is unchanged.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MISSING_DOCUMENT`}</strong>{` = 1148150605`}</p>
      <p parentName="blockquote">{`The book content object is missing because it has been moved, renamed, or deleted.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOCUMENT_OUT_OF_DATE`}</strong>{` = 1148150596`}</p>
      <p parentName="blockquote">{`The book content object has been modified after repagination.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOCUMENT_IN_USE`}</strong>{` = 1148150601`}</p>
      <p parentName="blockquote">{`The book content object is being used by someone else and is therefore locked.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOCUMENT_IS_OPEN`}</strong>{` = 1148150607`}</p>
      <p parentName="blockquote">{`The book content object is open.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      